const panel = document.querySelector('.panel');
const content = document.querySelector('#panel-content');
const regionButton = document.querySelector('.region-button');
const regionMenu = document.querySelector('#region-menu');
let opener;
const megaMenu = document.querySelector('.mega-menu');
const menuBackdrop = document.querySelector('.menu-backdrop');
const categoryButtons = document.querySelectorAll('.desktop-nav [data-category]');
const desktopHover = matchMedia('(min-width:1001px) and (hover:hover) and (pointer:fine)');
let megaCloseTimer;
let megaSource;
categoryButtons.forEach(button => { button.setAttribute('aria-expanded','false'); button.setAttribute('aria-controls','category-menu'); });
function closeMega() {
  clearTimeout(megaCloseTimer);
  megaMenu.hidden = true;
  menuBackdrop.hidden = true;
  categoryButtons.forEach(button => button.setAttribute('aria-expanded','false'));
}
function openMega(name, source) {
  clearTimeout(megaCloseTimer);
  megaSource = source;
  const bounds = source.getBoundingClientRect();
  megaMenu.style.left = bounds.left + 'px';
  megaMenu.style.top = bounds.bottom + 'px';
  if (!megaMenu.hidden && megaMenu.dataset.category === name) return;
  closeMega();
  regionMenu.hidden = true; regionButton.setAttribute('aria-expanded','false');
  document.querySelector('.mega-links').innerHTML = name === '品牌故事'
    ? '<a href="/collections/all?view=story">灵感与故事</a>'
    : name === '探索'
    ? '<a href="/collections/all?view=campaign">形象大片</a><button data-panel="collection">26F/W 花园系列</button>'
    : ['睡衣','内衣'].includes(name)
    ? '<a href="/collections/all?type=all">查看全部</a><a href="/collections/all?type=cami">吊带</a><a href="/collections/all?type=bra">文胸</a><a href="/collections/all?type=brief">内裤</a>'
    : name === '配饰' ? '<a href="/collections/all?type=accessory">查看全部</a>'
    : '<p class="saved-note">全新系列即将呈现。</p><button data-panel="collection">探索花园系列</button>';
  megaMenu.dataset.category = name;
  Locale.apply(megaMenu);
  megaMenu.hidden = false;
  source.setAttribute('aria-expanded','true');
}

const pages = {
  'story-menu': '<h2 id="panel-title">品牌故事</h2><nav class="panel-links"><a href="/collections/all?view=story">灵感与故事</a></nav>',
  menu: '<h2 id="panel-title">探索 ETTUNE</h2><nav class="panel-links" aria-label="移动端导航">' + ['睡衣','内衣','配饰','包'].map(name => `<button data-category="${name}">${name}</button>`).join('') + '<button data-panel="story-menu">品牌故事</button><button data-panel="collection">探索系列</button><button data-panel="account">我的账户</button><button data-panel="region">地区 / 货币</button></nav>',
  account: '<span class="eyebrow">MY ETTUNE</span><h2 id="panel-title">我的账户</h2><p>会员服务即将开放。</p><p>先走进 ETTUNE 的花园，探索全新系列。</p><button class="solid-button" data-panel="collection">探索系列</button>',
  bag: '<h2 id="panel-title">购物袋 <span style="font-size:18px">(0)</span></h2><svg class="empty-bag" viewBox="0 0 24 24"><path d="M5 7h14l1 14H4L5 7Z"/><path d="M9 8V5a3 3 0 0 1 6 0v3"/></svg><p>你的购物袋还是空的。</p><button class="solid-button" data-action="latest">探索新品</button>',
  search: '<h2 id="panel-title">寻找你的 ETTUNE</h2><label for="search-input" class="muted-label">搜索系列或品类</label><input id="search-input" class="search-input" type="search" placeholder="搜索吊带、文胸、内裤…" autocomplete="off"><div class="search-results" aria-live="polite"></div>',
  region: '<h2 id="panel-title">地区 / 货币</h2><div class="panel-links"><button data-region="UK (£)">United Kingdom · GBP £</button><button data-region="CN (¥)">中国大陆 · CNY ¥</button><button data-region="US ($)">United States · USD $</button><button data-region="EU (€)">Europe · EUR €</button></div>'
};
function openPanel(name, source) {
  if (name === 'account') { location.href=window.ETTUNEStore.accountUrl; return; }
  if (name === 'region') { Locale.open(source); return; }
  if (['product','collection','story'].includes(name)) { window.location.href = ({product:'/collections/all?view=piece',collection:'/collections/all',story:'/collections/all?view=story'})[name]; return; }
  if (!pages[name]) return;
  closeMega();
  if (!panel.open) opener = source || document.activeElement;
  regionMenu.hidden = true;
  regionButton.setAttribute('aria-expanded', 'false');
  content.innerHTML = name === 'bag' ? renderBag() : pages[name];
  Locale.apply(content);
  if (!panel.open) panel.showModal();
  panel.scrollTop = 0;
  if (name === 'bag') ETTUNECommerce.refreshBag();
  if (name === 'search') { renderSearch(''); document.querySelector('#search-input').focus(); }
  else document.querySelector('.close-button').focus();
}
function closePanel() { panel.close(); opener?.focus(); }
function renderSearch(value) {
  const query=value.trim().toLowerCase();
  const matches=Catalog.products.filter(p=> !query || [p.name.join(' '),Locale.text(p.name[0]),p.description.join(' '),Locale.text(p.description[0]),p.supplierCode||'',p.internalCode||'',p.id,p.category,Locale.text({cami:'吊带',bra:'文胸',brief:'内裤',accessory:'配饰'}[p.category]||p.category),...p.variants.map(v=>v.name.join(' ')+' '+Locale.text(v.name[0])+' '+(v.supplierCode||'')+' '+(v.internalCode||'')),'ETTUNE garden 花园 内衣 lingerie 2026'].join(' ').toLowerCase().includes(query));
  const e=Catalog.escape;
  document.querySelector('.search-results').innerHTML='<p class="muted-label">'+matches.length+' 个相关结果</p>'+matches.map(p=>`<a class="search-item" href="${Catalog.url(p)}">${Catalog.primary(p.variants[0])?`<img src="${e(Catalog.primary(p.variants[0]).src)}" alt="${e(p.name[0])}">`:'<span></span>'}<span>${e(p.name[0])}<small>${Catalog.optionCount(p)}</small></span></a>`).join('')+(matches.length?'':'<p>没有找到相关单品。</p>');
  Locale.apply(document.querySelector('.search-results'));
}
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-panel]');
  if (trigger) openPanel(trigger.dataset.panel, trigger);
  const category = event.target.closest('button[data-category]');
  if (category) {
    const name = category.dataset.category;
    if (name === '品牌故事') {
      if (!desktopHover.matches && !megaMenu.hidden && megaSource === category) closeMega();
      else openMega(name, category);
      return;
    }
    if (category.closest('.desktop-nav') && matchMedia('(min-width:1001px)').matches && !desktopHover.matches && event.detail > 0) {
      if (!megaMenu.hidden && megaSource === category) closeMega();
      else openMega(name, category);
      return;
    }
    const categorySlug={'睡衣':'sleepwear','内衣':'lingerie','配饰':'accessories','包':'bags'}[name];
    window.location.href = '/collections/all' + (categorySlug ? '?category=' + categorySlug : '');
    return;
  }
  if (event.target.closest('[data-action="latest"]')) { closePanel(); const latest = document.querySelector('#latest'); if (latest) latest.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}); else window.location.href = '/#latest'; }
  const region = event.target.closest('[data-region]');
  if (region) {
    regionButton.firstChild.textContent = region.dataset.region;
    document.querySelectorAll('[data-region]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.region === region.dataset.region)));
    regionMenu.hidden = true; regionButton.setAttribute('aria-expanded','false');
    if (panel.open) closePanel();
  }
  if (!event.target.closest('.region-control')) { regionMenu.hidden = true; regionButton.setAttribute('aria-expanded','false'); }
});
document.addEventListener('input', event => { if (event.target.id === 'search-input') renderSearch(event.target.value); });
document.querySelector('.close-button').addEventListener('click', closePanel);
panel.addEventListener('click', event => { if (event.target === panel) { const rect = panel.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right) closePanel(); } });
panel.addEventListener('cancel', event => { event.preventDefault(); closePanel(); });
regionButton.addEventListener('click', () => Locale.open(regionButton));
document.addEventListener('keydown', event => { if(event.key === 'Escape' && !regionMenu.hidden) { regionMenu.hidden = true; regionButton.setAttribute('aria-expanded','false'); regionButton.focus(); } });

// A small delay lets the pointer cross from a category into its submenu.
function scheduleMegaClose() {
  clearTimeout(megaCloseTimer);
  megaCloseTimer = setTimeout(closeMega, 180);
}
categoryButtons.forEach(button => {
  button.addEventListener('pointerenter', event => {
    if (desktopHover.matches && event.pointerType !== 'touch') openMega(button.dataset.category, button);
  });
  button.addEventListener('pointerleave', () => { if (desktopHover.matches) scheduleMegaClose(); });
  button.addEventListener('keydown', event => {
    if (event.key !== 'ArrowDown') return;
    event.preventDefault();
    openMega(button.dataset.category, button);
    megaMenu.querySelector('button,a')?.focus();
  });
});
megaMenu.addEventListener('pointerenter', () => clearTimeout(megaCloseTimer));
megaMenu.addEventListener('pointerleave', () => { if (desktopHover.matches) scheduleMegaClose(); });
megaMenu.addEventListener('keydown', event => {
  const items = [...megaMenu.querySelectorAll('button,a')];
  const index = items.indexOf(document.activeElement);
  if (index < 0 || !['ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
  event.preventDefault();
  const next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
  items[next].focus();
});
document.addEventListener('focusin', event => {
  if (!megaMenu.hidden && event.target !== megaSource && !megaMenu.contains(event.target)) closeMega();
});
document.addEventListener('pointerdown', event => {
  if (!megaMenu.contains(event.target) && !event.target.closest('.desktop-nav [data-category]')) closeMega();
});
window.addEventListener('scroll', closeMega, {passive:true});
window.addEventListener('resize', closeMega);
document.addEventListener('keydown', event => { if (event.key === 'Escape' && !megaMenu.hidden) { const active = document.querySelector('.desktop-nav [aria-expanded="true"]'); closeMega(); active?.focus(); } });
matchMedia('(max-width:1000px)').addEventListener('change', closeMega);
const gallery = document.querySelector('.collection-track');
const previous = document.querySelector('[data-gallery="prev"]');
const next = document.querySelector('[data-gallery="next"]');
function updateGallery() {
  if (!gallery) return;
  const max = gallery.scrollWidth - gallery.clientWidth;
  previous.disabled = gallery.scrollLeft < 5;
  next.disabled = gallery.scrollLeft >= max - 5;
  const cards=[...gallery.children];
  const index=cards.reduce((best,card,i)=>Math.abs(card.offsetLeft-gallery.offsetLeft-gallery.scrollLeft)<Math.abs(cards[best].offsetLeft-gallery.offsetLeft-gallery.scrollLeft)?i:best,0);
  document.querySelector('.collection-position').textContent=String(index+1).padStart(2,'0')+' / '+String(cards.length).padStart(2,'0');
}
document.querySelectorAll('[data-gallery]').forEach(button => button.addEventListener('click', () => {
  gallery.scrollTo({left:gallery.scrollLeft + (button.dataset.gallery === 'next' ? 1 : -1) * (gallery.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(gallery).gap)), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
}));
gallery?.addEventListener('scroll', updateGallery, {passive:true});
window.addEventListener('resize', updateGallery);
updateGallery();

let bagQuantity=0;
function updateBagCount(){ETTUNECommerce.updateCount();}
function renderBag(){return ETTUNECommerce.renderBag();}
ETTUNECommerce.refresh();

// Keep the navigation transparent; change only the foreground after the hero.
const fixedHeader = document.querySelector('.header');
const homeHero = document.querySelector('.hero');
if (fixedHeader && homeHero) {
  let headerFramePending = false;
  function updateHeaderContrast() {
    fixedHeader.classList.toggle('is-on-light', homeHero.getBoundingClientRect().bottom <= fixedHeader.offsetHeight / 2);
    headerFramePending = false;
  }
  function scheduleHeaderContrast() {
    if (headerFramePending) return;
    headerFramePending = true;
    requestAnimationFrame(updateHeaderContrast);
  }
  window.addEventListener('scroll', scheduleHeaderContrast, {passive:true});
  window.addEventListener('resize', scheduleHeaderContrast);
  window.addEventListener('pageshow', updateHeaderContrast);
  updateHeaderContrast();
}


document.addEventListener('localechange',()=>{updateBagCount();if(document.querySelector('#search-input'))renderSearch(document.querySelector('#search-input').value);});
